// @ts-expect-error Could not find a declaration file for module
import TrackExamPageContainer from './TrackExamPageContainer';
// @ts-expect-error Could not find a declaration file for module
import TrackPageContainer from './TrackPageContainer';
// @ts-expect-error Could not find a declaration file for module
import TrackIntroPageContainer from './TrackIntroPageContainer';
// @ts-expect-error Could not find a declaration file for module
import TrackFinishedPageContainer from './TrackFinishedPageContainer';
import { TrackRecommendations } from '../../features/recommendations';
import { TRACK_EXAM_URL_FRAGMENT, TRACK_INTRO_URL_FRAGMENT, TRACK_COMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT } from '../../constants/Navigation';
import { NextPlaylistContentOverview, PlaylistComplete, PlaylistIncompleteItems } from '../../features/playlistContent';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackBody = ({
  trackId,
  lessonId,
  contentId,
  language,
  name
}) => {
  switch (lessonId) {
    case TRACK_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(TrackFinishedPageContainer, {
        trackId: trackId
      });
    case TRACK_EXAM_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(TrackExamPageContainer, {
        language: language,
        trackId: trackId
      });
    case TRACK_INTRO_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(TrackIntroPageContainer, {
        language: language,
        trackId: trackId
      });
    case TRACK_RECOMMENDATIONS_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(TrackRecommendations, {
        language: language,
        name: name,
        trackId: Number(trackId)
      });
    case TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT:
      {
        return /*#__PURE__*/_jsx(NextPlaylistContentOverview, {
          lessonId: Number(lessonId),
          trackId: Number(trackId)
        });
      }
    case TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistIncompleteItems, {});
    case TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistComplete, {});
    default:
      {
        return /*#__PURE__*/_jsx(TrackPageContainer, {
          contentId: contentId,
          language: language,
          lessonId: lessonId,
          trackId: trackId
        });
      }
  }
};
export default TrackBody;